
























import {
    Component,
    Vue,
    Inject,
} from 'vue-property-decorator';
import { Channel } from 'phoenix';
import WebSocket from '@/socket';
import HttpClient from '@/api/http-client';
import Logger from '@/utils/logger/logger';
import { urlWebSocket } from '@/utils/url';
import StatsCard from '@/components/GlobalPanorama/StatsCard.vue';
import createQueueChannel from '@/utils/queue/channel';
import { Queue, QueueChannel } from '@/store/modules/queue';
import { Agent } from '@/store/modules/agent';
// import UserInfo from '@/core/userinfo'; // TODO: descomentar cuando se agregue validación de permisos

@Component({
    components: {
        StatsCard,
    },
})
export default class GlobalPanorama extends Vue {
    @Inject('logger') logger!: Logger;

    @Inject('httpClient') http!: HttpClient;

    socket!: WebSocket;

    queuesChannel!: Channel;

    agentsChannel!: Channel;

    queueChannels: Channel[] = [];

    async created() {
        const token = sessionStorage.getItem('token') || '';
        this.socket = WebSocket.fromToken(urlWebSocket, token, this.logger);

        this.queuesChannel = this.socket.channel('queues:all');
        this.agentsChannel = this.socket.channel('agents:all');

        const joinTimeout = 240000;

        // Escuchar lista de queues y crear canales individuales
        this.queuesChannel.on('all_queues', (data) => {
            data.queues.forEach((queue: QueueChannel) => {
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                const channel = createQueueChannel(queue.name, this.socket, this.$store, () => {});

                this.$store.dispatch('addQueueToContainer', {
                    name: queue.name,
                    tiers: [],
                    visible: true,
                    membersCount: 0,
                    callsAnswered: 0,
                    agentOffers: new Map(),
                    memberCalls: new Map(),
                    metadata: { name: queue.metadata?.name },
                    isLoading: false,
                    channel,
                });

                channel.join(joinTimeout).receive('error', (err) => {
                    this.logger.captureError(err);
                });

                this.queueChannels.push(channel);
            });
        });

        // Escuchar lista de agentes
        this.agentsChannel.on('all_agents', (data) => {
            data.agents.forEach((agent: { name: string; metadata: { name: string } }) => {
                this.$store.dispatch('addAgentToContainer', {
                    name: agent.name,
                    tiers: [],
                    status: '',
                    state: '',
                    callStates: new Map(),
                    queueCalls: new Map(),
                    isLoading: false,
                    metadata: { name: agent.metadata?.name },
                    connected: false,
                    lastActivityAtSecs: 0,
                    previousState: '',
                    doNotDisturb: false,
                });
            });
        });

        this.queuesChannel.join(joinTimeout).receive('error', (err) => {
            console.error('Failed to join queues:all', err);
            this.logger.captureError(err);
        });

        this.agentsChannel.join(joinTimeout).receive('error', (err) => {
            console.error('Failed to join agents:all', err);
            this.logger.captureError(err);
        });
    }

    beforeDestroy() {
        if (this.queuesChannel) this.queuesChannel.leave();
        if (this.agentsChannel) this.agentsChannel.leave();
        this.queueChannels.forEach((ch) => ch.leave());
    }

    // En Espera: suma de membersCount de todas las queues
    get waitingCount(): number {
        const queueNames: string[] = this.$store.getters.queueNames();
        return queueNames.reduce((total: number, name: string) => {
            const queue: Queue = this.$store.getters.getQueueByName(name);
            return total + (queue?.membersCount || 0);
        }, 0);
    }

    // En Curso: contar queueCalls únicos de todos los agentes
    get activeCount(): number {
        const queuesContainer = this.$store.state.queuesContainer || {};
        const uniqueCalls = new Set<string>();

        Object.values(queuesContainer).forEach((queue: unknown) => {
            const q = queue as Queue;
            if (q.agentOffers) {
                q.agentOffers.forEach((offer) => {
                    uniqueCalls.add(offer.member_uuid);
                });
            }
        });

        // También contar desde los agentes sus queueCalls
        const agentsContainer = this.$store.state.agentsContainer || {};
        Object.values(agentsContainer).forEach((agent: unknown) => {
            const a = agent as Agent;
            if (a.queueCalls) {
                a.queueCalls.forEach((call) => {
                    uniqueCalls.add(call.call);
                });
            }
        });

        return uniqueCalls.size;
    }

    // Agentes en línea: contar agentes conectados
    get agentsOnlineCount(): number {
        const agentsContainer = this.$store.state.agentsContainer || {};
        let count = 0;
        Object.values(agentsContainer).forEach((agent: unknown) => {
            const a = agent as Agent;
            if (a.connected) {
                count += 1;
            }
        });
        return count;
    }
}
